import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { SlaSnackbarComponent } from './sla-snackbar.component';

export * from './sla-snackbar.component';

@NgModule({
    declarations: [
        SlaSnackbarComponent,
    ],
    imports: [
        CommonModule,
        MatIconModule,
        TranslateModule,
        MatSnackBarModule,
    ],
    exports: [
        SlaSnackbarComponent,
    ],
})
export class SlaSnackbarModule {}
